// extracted by mini-css-extract-plugin
export default {"footerNav":"gz_kG","footerItem":"EJ0jx"};